module.exports = {
    pickup: {
        pickupSubmitError: 'Please provide all Pick up information to continue.',
    },
};



// WEBPACK FOOTER //
// ./src/common/settings/groups/pickup.js